/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scan_To_PlayInputs */

const en_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan to Play`)
};

const es_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escanear para reproducir`)
};

const fr_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scanner pour lire`)
};

const de_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Abspielen scannen`)
};

const ja_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スキャンして再生`)
};

const zh_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扫码播放`)
};

const ar_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امسح للتشغيل`)
};

const id_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pindai untuk Memutar`)
};

const it_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scansiona per riprodurre`)
};

const ru_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сканировать для воспроизведения`)
};

const pt_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitalize para reproduzir`)
};

const ko_scan_to_play = /** @type {(inputs: Scan_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스캔하여 재생`)
};

/**
* | output |
* | --- |
* | "Scan to Play" |
*
* @param {Scan_To_PlayInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const scan_to_play = /** @type {((inputs?: Scan_To_PlayInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scan_To_PlayInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scan_to_play(inputs)
	if (locale === "es") return es_scan_to_play(inputs)
	if (locale === "fr") return fr_scan_to_play(inputs)
	if (locale === "de") return de_scan_to_play(inputs)
	if (locale === "ja") return ja_scan_to_play(inputs)
	if (locale === "zh") return zh_scan_to_play(inputs)
	if (locale === "ar") return ar_scan_to_play(inputs)
	if (locale === "id") return id_scan_to_play(inputs)
	if (locale === "it") return it_scan_to_play(inputs)
	if (locale === "ru") return ru_scan_to_play(inputs)
	if (locale === "pt") return pt_scan_to_play(inputs)
	return ko_scan_to_play(inputs)
});